import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import {
    CONTEXT_DEMANDE_ARME_HERITEE,
    CONTEXT_DEMANDE_ARME_TROUVEE,
} from '../../../constants/apiUrls.constants';

const demandeArmeTrouveeHeritee = combineReducers({
    demandeArmeTrouvee: APIReducer.bind(null, CONTEXT_DEMANDE_ARME_TROUVEE),
    demandeArmeHeritee: APIReducer.bind(null, CONTEXT_DEMANDE_ARME_HERITEE),
});

export default demandeArmeTrouveeHeritee;
